import { FileInput } from '@mantine/core';
import { useDispatch } from 'react-redux';
import Papa from 'papaparse';
import { useState } from 'react';

import { NotificationType, showNotification } from '../../../utils/showNotifications';
import { setLoadingMessage, setShowGlobalLoading } from '../../../store/slices/appSlice';

import { validateHeaders } from '../helpers';

import { getModelDataResponse } from '../services';
import { updateSpeciesDataModel } from '../../../services/aws';

import { requiredFields } from '../../../config/adminRequiredHeaders.config';
import store from '../../../store/store';

import WFIDButton from '../../../components/WFIDButton/WFIDButton';
import {
  NotificationOptionTypes,
  setMissingFields,
  setNotificationModalOpen,
  setNotificationType,
} from '../../../store/slices/adminSlice';

let fileData = null as any;
const validateFile = (file: File) => {
  const hashMapFields = new Map<string, string>();

  if (file) {
    Papa.parse(file, {
      complete: (result) => {
        result.meta.fields?.forEach((field) => {
          hashMapFields.set(field, field);
        });
        if (result.errors?.length) {
          console.error('Error parsing file', result.errors);

          return false;
        }
        const missingFields = validateHeaders(requiredFields, hashMapFields);

        fileData = result.data;
        if (missingFields.length) {
          // show error message
          store.dispatch(setMissingFields(missingFields));
          store.dispatch(setNotificationModalOpen(true));
          store.dispatch(setNotificationType(NotificationOptionTypes.MissingHeaders));
        } else {
          fileData = result.data;
        }
      },
      header: true,
      skipEmptyLines: true,
    });
  }
};

const CreateModelGenusS3Data = () => {
  const [file, setFile] = useState<File | null>(null);
  const dispatch = useDispatch();

  const handleFileChange = (value: File | null) => {
    if (!value) {
      setFile(null);
      return;
    }
    // split name by "_" and check if it follows naming convention of "{filename}_50.csv";
    const fileNameParts = value.name.split('_');
    const lastPart = fileNameParts[fileNameParts.length - 1];
    // check if last item contains "50";
    const isValidFileName = lastPart.includes('50');
    // if not, show error message and return
    if (!isValidFileName) {
      showNotification({
        type: NotificationType.Error,
        title: 'Error',
        message: 'File name must follow the naming convention of "{filename}_50.csv"',
      });
      return;
    }
    if (!value?.name.endsWith('.csv')) {
      showNotification({
        type: NotificationType.Error,
        title: 'Error',
        message: 'Only CSV files are allowed',
      });
      return;
    }
    setFile(value);
    validateFile(value);
  };

  const handleUpdate = async () => {
    const subFolderName = 'model-predictions-per-genus';
    const fileName = `${subFolderName}/${file?.name}`;
    dispatch(setShowGlobalLoading(true));
    dispatch(setLoadingMessage('Creating...'));

    const body = {
      body: JSON.stringify({
        fileName,
        newContent: fileData,
      }),
    };
    if (fileData?.length) {
      const response = await updateSpeciesDataModel(body);
      if (!response?.success) {
        // show error message
        showNotification({
          type: NotificationType.Error,
          title: 'Error',
          message: 'There was an error, please try again',
        });
        dispatch(setShowGlobalLoading(false));
        dispatch(setLoadingMessage(''));

        return;
      }
      showNotification({
        type: NotificationType.Success,
        title: 'Success',
        message: 'Model prediction created successfully',
      });
      dispatch(setShowGlobalLoading(false));
      dispatch(setLoadingMessage(''));

      setFile(null);
      fileData = null;

      // get the updated list of models
      await getModelDataResponse();
    }
  };

  return (
    <div>
      <div className='input-file-wrapper'>
        <FileInput
          placeholder='Choose file'
          className='file-upload'
          value={file}
          withAsterisk
          variant='deafult'
          clearable
          size='md'
          w={200}
          accept='.csv'
          onChange={handleFileChange}
        />
      </div>

      <div className='admin-buttons-container'>
        <WFIDButton disabled={!file} bgColor='white' content='Add' onClick={handleUpdate} />
      </div>
    </div>
  );
};

export default CreateModelGenusS3Data;
